import { combineReducers } from "redux";
import { appTokenReducer } from './appToken/appTokenIndex';
import { rootDetectionReducer } from './rootDetection/rootDetectionIndex';
import { loyaltyProgramReducer } from './loyalty/program/loyaltyProgramIndex';
import { loyaltyNotificationsReducer } from './loyalty/notifications/loyaltyNotificationsIndex';
import { loyaltyToastReducer } from './loyalty/toast/loyaltyToastIndex';
import { loyaltyLocationsReducer } from './loyalty/locations/loyaltyLocationsIndex';
import { loyaltyMembersReducer } from './loyalty/members/loyaltyMembersIndex';
import { loyaltyRewardsReducer } from './loyalty/rewards/loyaltyRewardsIndex';
import { loyaltyAutomatedRewardsReducer } from './loyalty/automatedRewards/loyaltyAutomatedRewardsIndex';
import { productCatalogReducer } from './productCatalog/productCatalogReducer';
import { displayReducer } from './display/display/displayIndex';
import { mediaLibraryReducer } from './display/mediaLibrary/mediaLibraryIndex';
import { playlistReducer } from './display/playlist/playlistIndex';
import { clickHouseReducer } from './reports/clickHouse/clickHouseIndex';
import { ReportsChatbotReducer } from './reports/ReportsChatbot/ReportsChatbotIndex';
import { ProductCatalogChatbotReducer } from './productCatalog/ProductCatalogChatbot/ProductCatalogChatbotIndex';
import { reservationReportReducer } from './reports/reservationReport/reservationReportIndex';
import { serverInfoReducer } from './serverInfo/serverInfoIndex';
import { offerManagementReducer } from './offers/offerReducer';
import { RESET_REPORTS_DATA } from './globalActions';
import { cateringReducer } from './catering/cateringReducer';
import { mediaManagementReducer } from './mediaManagement/mediaManagementIndex';
import { campaignsReducer } from './campaigns/campaignsIndex';
import { customerReducer } from './customers/customerIndex';

const appReducer = combineReducers({
  appToken: appTokenReducer,
  rootDetection: rootDetectionReducer,
  loyaltyProgram: loyaltyProgramReducer,
  loyaltyNotifications: loyaltyNotificationsReducer,
  loyaltyToast: loyaltyToastReducer,
  loyaltyLocations: loyaltyLocationsReducer,
  loyaltyMembers: loyaltyMembersReducer,
  loyaltyRewards: loyaltyRewardsReducer,
  loyaltyAutomatedRewards: loyaltyAutomatedRewardsReducer,
  productCatalog: productCatalogReducer,
  display: displayReducer,
  mediaLibrary: mediaLibraryReducer,
  playlist: playlistReducer,
  clickHouse: clickHouseReducer,
  ReportsChatbot: ReportsChatbotReducer,
  ProductCatalogChatbot: ProductCatalogChatbotReducer,
  reservationReport: reservationReportReducer,
  serverInfo: serverInfoReducer,
  offerManagement: offerManagementReducer,
  catering: cateringReducer,
  mediaManagement: mediaManagementReducer,
  campaigns: campaignsReducer,
  customers: customerReducer,
});

// data so a different account never sees the prior session's numbers. Setting
// these slices to `undefined` makes combineReducers reinitialize each one to
// its own initialState. Device/app-level slices (appToken, rootDetection) are
// intentionally left untouched.
const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_REPORTS_DATA && state) {
    state = {
      ...state,
      clickHouse: undefined,
      reservationReport: undefined,
      ReportsChatbot: undefined,
      offersReport: undefined,
      eodClickhouse: undefined,
      reportFilters: undefined,
      mediaManagement: undefined,
      campaigns: undefined,
    };
  }
  return appReducer(state, action);
};

export { rootReducer };

export type RootState = ReturnType<typeof appReducer>;
